/**
 * Token hashing utility for secure KV storage.
 *
 * Tokens are stored in KV using their SHA-256 hash as the key,
 * prefixed with "th_" to distinguish from legacy raw-token keys.
 */

/**
 * Hash a raw API token using SHA-256 for secure KV storage.
 * Returns "th_" + hex(SHA-256(rawToken)).
 */
export async function hashToken(rawToken: string): Promise<string> {
  const encoded = new TextEncoder().encode(rawToken);
  const hash = await crypto.subtle.digest('SHA-256', encoded);
  const hex = Array.from(new Uint8Array(hash))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
  return `th_${hex}`;
}
